import { LITIGATION_COURTS, LITIGATION_PRACTICES, LITIGATION_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type LitigationQA = WaveQA;

export const LITIGATION_REVIEWED_TH = "สิงหาคม 2569";
export const LITIGATION_REVIEWED_ISO = "2026-08-07";

export const LITIGATION_QA: LitigationQA[] = buildLegalClusterQA({
  prefix: "litigation",
  clusterTh: "งานว่าความ ระงับข้อพิพาท และอนุญาโตตุลาการ",
  authorityTh: "ศาลหรือสถาบันอนุญาโตตุลาการที่มีเขตอำนาจ",
  reviewedTh: LITIGATION_REVIEWED_TH,
  volatileNote:
    "ระเบียบศาล ค่าธรรมเนียม และกำหนดเวลาตามกฎหมายเปลี่ยนได้ ควรยืนยันกับศาลหรือทนายผู้รับผิดชอบคดีก่อนดำเนินการ",
  topics: toAxis(LITIGATION_SERVICES),
  extraTopics: [...toAxis(LITIGATION_COURTS, "court"), ...toAxis(LITIGATION_PRACTICES, "area")],
});

export const LITIGATION_QA_BY_SLUG: Record<string, LitigationQA> = Object.fromEntries(
  LITIGATION_QA.map((qa) => [qa.slug, qa]),
);

export const LITIGATION_QA_COUNT = LITIGATION_QA.length;
